import { AssistantItems } from '@repo/shared/dtos/assistant'
import { useAsyncData } from '@repo/ui/dataProvider'

import { AssistantMessage } from '@/components/assistant/messages/AssistantMessage'
import { BeneficiaryLink } from '@/components/beneficiary/BeneficiaryLink'

export function CtaProfile({ item }: { item: AssistantItems['beneficiaryProfile'] }) {
  if (item.cta !== 'profile') return null

  const {
    data: [beneficiaries],
  } = useAsyncData([(state) => state.beneficiary.all])

  if (!beneficiaries) return null

  const beneficiary = beneficiaries?.find(({ id }) => id === item.profileId)

  if (!beneficiary) return null
  return (
    <AssistantMessage
      traceUrl={item.traceUrl}
      key={item.id}
      className="flex flex-col gap-1 leading-snug"
    >
      <BeneficiaryLink
        className="text-primary-200 hover:text-primary-50 text-base"
        id={beneficiary.id}
        fullName={beneficiary.fullName}
      />
      {item.content}
    </AssistantMessage>
  )
}
